import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledPopoverContent = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 8px;
`;

export const StyledSpeakersList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;
  &.scrollbar-custom {
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.tooltipColor};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.tooltipColor};
      border-radius: 100px;
    }
  }
`;

export const StyledAddSpeakerButton = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  gap: 16px;
`;
